import { IconChevronLeft, IconChevronRight } from '@tabler/icons-react';
import type { InterviewData } from '../../types';
import { getResponseDisplayName } from '../../lib/admin-utils';
import { Skeleton } from '../ui/Skeleton';
import { Select } from '../ui/Select';
import { AnimatedLabel } from '../ui/AnimatedLabel';

/** Compact response browsing stays beside the response content. */
export function CampaignResponseNavigation({ response, responses, onSelect }: {
  response?: InterviewData;
  responses: readonly InterviewData[];
  onSelect: (id: string) => void;
}) {
  const index = responses.findIndex(item => item.id === response?.id);
  const button = 'flex h-10 shrink-0 cursor-pointer items-center gap-2 rounded-lg px-2 sm:px-3 text-sm text-muted-foreground transition-colors motion-reduce:transition-none hover:bg-surface-hover hover:text-foreground disabled:cursor-not-allowed disabled:opacity-40';
  return <nav aria-label="Response navigation" className="ml-auto flex min-w-0 shrink-0 items-center gap-1">
      <button type="button" aria-label="Previous response" className={button} disabled={index <= 0} onClick={() => { if (index > 0) onSelect(responses[index - 1].id); }}><IconChevronLeft size={16} aria-hidden /></button>
      <Select compact ariaLabel="Choose response" className="min-w-0 w-24 sm:w-56 max-w-[40vw]" disabled={!response} value={response?.id ?? ''} onChange={onSelect}
        selectedContent={<span className="flex min-w-0 items-center gap-1">
          {response ? <AnimatedLabel text={getResponseDisplayName(response)} truncate className="min-w-0" /> : <Skeleton width="6em" />}
          {response?.response_number ? <AnimatedLabel text={`#${response.response_number}`} className="shrink-0" /> : null}
        </span>}
        options={responses.map(item => ({ value: item.id, label: `${getResponseDisplayName(item)}${item.response_number ? ` #${item.response_number}` : ''}` }))} />
      <button type="button" aria-label="Next response" className={button} disabled={index < 0 || index >= responses.length - 1} onClick={() => { if (index >= 0 && index < responses.length - 1) onSelect(responses[index + 1].id); }}><IconChevronRight size={16} aria-hidden /></button>
  </nav>;
}
